window.theme = window.theme || {};
theme.LanguageDropDown = (function($) {

  var selectors = {
    dropDown: '.jsLanguageDropDownList',
    dropDownItem: '.jsLanguageDropDownListItem',
    dropDownItemValue: '.jsLanguageDropDownListItemValue',
  };
  var classes = {
    dropDownItemSelected: 'disclosure__link--active'
  };
  var dataKeys = {
    dropDownItemValue: 'dropdown-item-value'
  };
  var cache = {};

  function init() {
    cacheSelectors();
    if(sessionStorage.language == null && !isCrawler()){
      changeLanguage(getLanguage());
    }
    cache.$dropDown.find(selectors.dropDownItem).on('click', function () {
      if (!$(this).hasClass(classes.dropDownItemSelected)) {
        selectItem(cache.$dropDown, $(this));
        var selectedValue = getDropDownItemValue($(this));
        changeLanguage(selectedValue);
      }
    })
  }

  function cacheSelectors() {
    cache = {
      $dropDown: $(selectors.dropDown)
    };
  }

  function isCrawler() {
    var botPattern = "(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)"
    var re = new RegExp(botPattern, 'i')
    var userAgent = navigator.userAgent

    if (re.test(userAgent)) {
      return true
    } else {
      return false
    }
  }

  function getLanguage() {
    var storeLanguages = window.currentLocalesShopPublished
    var spainishLanguagesRegex = /^(ca|gl|eu)/
    if (spainishLanguagesRegex.test(navigator.language.slice(0,2)))
      lang = 'es'
    else
      lang = storeLanguages.includes(navigator.language.slice(0,2)) ? navigator.language.slice(0,2) : 'en'
    return lang
  }

  function getDropDownItemValue($dropDownItem) {
    return $dropDownItem.find(selectors.dropDownItemValue).data(dataKeys.dropDownItemValue);
  }

  function selectItem($dropDown, $dropDownItem) {
    $dropDown.find(selectors.dropDownItem).each(function () {
      $(this).removeClass(classes.dropDownItemSelected);
    });
    $dropDownItem.addClass(classes.dropDownItemSelected);
  }

  function changeLanguage(language) {
    saveLanguage(language)
    reloadByLocation(language)
  }

  function reloadByLocation(language) {
    var storeLanguages = window.currentLocalesShopPublished
    var spainishLanguagesRegex = /^(es|ca|gl|eu)/
    var newLanguagePath = null
    if (spainishLanguagesRegex.test(language)) {
      var expression = new RegExp("^\/" + buildOriginUrlWithLanguagesRegExpString(storeLanguages))
      needToRefresh = expression.test(location.pathname);
    } else {
      newLanguagePath = language;
      var expression = new RegExp("^\/" + buildOriginUrlWithLanguagesRegExpString([language]))
      needToRefresh = !expression.test(location.pathname);
    }
    
    if (needToRefresh) {
      var allLanguageRegExpString = buildOriginUrlWithLanguagesRegExpString(storeLanguages)
      var languagePathRegExpToReplace = new RegExp("^" + allLanguageRegExpString + "$")
      listOfPaths = location.pathname.split('/')
      if (languagePathRegExpToReplace.test(listOfPaths[1])) {
        if (newLanguagePath) {
          listOfPaths[1] = newLanguagePath
        } else {
          listOfPaths.splice(1, 1)
        }
      } else {
        if (newLanguagePath) {
          listOfPaths.splice(1, 0, newLanguagePath)
        }
      }
      location.replace(location.origin + listOfPaths.join('/'))
    }
  }

  function buildOriginUrlWithLanguagesRegExpString(languages) {
    languages = languages || [];
    return "(" + languages.join('|') + ")"
  }

  function saveLanguage(language) {
    sessionStorage.setItem('language', language)
  }

  return {
    init: init
  }
})(jQuery);

